import { Contacts } from "@/models/commons";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { cn, formatPhoneNumber } from "@/lib/utils";

export function ContactCard({ contact }: { contact: Contacts[number] }) {
  return (
    <Card x-chunk="dashboard-01-chunk-0" className="bg-background">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-base font-medium">
          {contact.name || "-"}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold">{contact.type}</div>
        <p className="text-sm text-muted-foreground mt-3 break-words">
          {contact.email || "-"}
        </p>
        <p className="text-sm text-muted-foreground mt-1 break-words">
          {formatPhoneNumber(contact.phone)}
        </p>
      </CardContent>
    </Card>
  );
}

export function ContactList({
  list,
  className,
}: {
  list: Contacts;
  className?: string;
}) {
  return (
    <ul
      className={cn(
        "grid gap-4",
        list.length > 1 ? "grid-cols-2" : "",
        className
      )}
    >
      {list.map((contact, i) => (
        <li key={i}>
          <ContactCard contact={contact} />
        </li>
      ))}
    </ul>
  );
}
